import React from "react";
import { withRouter } from "react-router-dom";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import ErrorBoundary from "./ErrorBoundary";
import Button from "./utilities/Button";
import loading from "../img/loading.svg";

const WEEK_DAYS = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday"
];
class CreateUser extends React.Component {
  constructor(props) {
    super();

    this.state = {
      email: "",
      password: "",
      name: "",
      loading: false,
      error: false,
      success: false,
      isDoctor: false
    };
  }
  handleIsDoctor = event => {
    this.setState({
      isDoctor: event.target.checked
    });
  };

  render() {
    return (
      <ErrorBoundary>
        <div className="column is-4">
          <div className="card">
            <header className="card-header">
              <h1 className="card-header-title has-text-centered is-size-3">
                Créer un utilisateur
              </h1>
            </header>
            <div className="card-content  has-text-left">
              <form onSubmit={this.handleSubmit}>
                <div className="field">
                  <label className="label">Email</label>
                  <div className="control">
                    <input
                      value={this.state.email}
                      className={`input ${this.state.error ? "is-danger" : ""}`}
                      type="email"
                      onChange={e => this.setState({ email: e.target.value })}
                    />
                  </div>
                </div>
                <div className="field">
                  <label className="label">Nom</label>
                  <div className="control">
                    <input
                      value={this.state.name}
                      className={`input ${this.state.error ? "is-danger" : ""}`}
                      type="text"
                      placeholder="Dr. Machin"
                      onChange={e => this.setState({ name: e.target.value })}
                    />
                  </div>
                </div>
                <div className="field">
                  <label className="checkbox">
                    <input
                      type="checkbox"
                      onChange={this.handleIsDoctor}
                      checked={this.state.isDoctor ? true : false}
                    />{" "}
                    est un médecin
                  </label>
                </div>
                <div className="field">
                  <label className="label">Mot de passe</label>
                  <div className="control">
                    <input
                      required
                      className={`input  ${this.state.error
                        ? "is-danger"
                        : ""}`}
                      type="password"
                      value={this.state.password}
                      onChange={e =>
                        this.setState({ password: e.target.value })}
                    />
                  </div>
                </div>
                <div className="field  has-text-centered">
                  {this.state.loading ? (
                    <figure
                      style={{
                        marginBottom: "-10px"
                      }}
                      className="image is-32x32"
                    >
                      <img alt="loading" src={loading} />
                    </figure>
                  ) : null}
                  <Button
                    text="Créer"
                    type="submit"
                    disabled={this.state.loading}
                  />
                </div>
                {this.state.success ? (
                  <div className="field  has-text-centered has-text-centered has-text-success">
                    Utilisateur créé avec succès!
                  </div>
                ) : null}
              </form>
            </div>
          </div>
        </div>
      </ErrorBoundary>
    );
  }
  handleSubmit = e => {
    e.preventDefault();
    this.signupUser();
  };
  createDefaultWeek = async doctorId => {
    const { createWeekMutation } = this.props;
    //const returnWeekDays = this.weekDays;

    let promises = WEEK_DAYS.map(day => {
      return this.props
        .createWeekDayMutation({
          variables: { day }
        })
        .then(({ data }) => {
          return data.createWeekDay.id;
        });
    });
    Promise.all(promises).then(async ids => {
      const daysIds = ids;
      await createWeekMutation({
        variables: { doctorId, daysIds }
      }).catch(e => {
        this.setState({
          loading: false
        });
        console.error("createWeekMutation: ", e);
      });
    });
  };
  signupUser = async () => {
    const { email, password, name, isDoctor } = this.state;
    let role = isDoctor ? "DOCTOR" : "SECRETARY";
    this.setState({
      loading: true
    });
    try {
      const user = await this.props.signupUserMutation({
        variables: { email, password, name, role }
      });
      //    localStorage.setItem("graphcoolToken", user.data.signupUser.token);
      //create options
      if (role === "DOCTOR") {
        const doctorId = user.data.signupUser.id;
        await this.props
          .createOptionsMutation({
            variables: { doctorId }
          })
          .catch(e => {
            console.error("create  options", e);
            this.setState({
              loading: false
            });
          });
        //create week
        this.createDefaultWeek(doctorId).then(() => {
          //        this.props.history.replace("/");
        });
      }
      this.setState({
        loading: false,
        email: "",
        password: "",
        name: "",
        error: false,
        isDoctor: false,
        emailSubscription: false,
        success: true
      });
      this.props.setRefetch(true);
    } catch (e) {
      console.error(`An error occured: `, e);
      this.setState({ error: true, loading: false });
      //this.props.history.replace("/");
    }
  };
}

const SIGNUP_USER_MUTATION = gql`
  mutation createUserMutation(
    $email: String!
    $password: String!
    $name: String
    $role: String
  ) {
    signupUser(email: $email, password: $password, name: $name, role: $role) {
      id
      token
    }
  }
`;

const CREATE_OPTIONS_MUTATION = gql`
  mutation CreateOptions($doctorId: ID!) {
    createOptions(doctorId: $doctorId) {
      id
    }
  }
`;

const CREATE_WEEKDAY_MUTATION = gql`
  mutation CreateWeekDay($day: String!) {
    createWeekDay(day: $day) {
      id
    }
  }
`;
const CREATE_WEEK_MUTATION = gql`
  mutation CreateWeek($doctorId: ID!, $daysIds: [ID!]!) {
    createWeek(doctorId: $doctorId, daysIds: $daysIds) {
      id
      days {
        dayTemplate {
          id
          name
        }
        id
        day
      }
    }
  }
`;

export default compose(
  graphql(SIGNUP_USER_MUTATION, { name: "signupUserMutation" }),
  graphql(CREATE_WEEK_MUTATION, {
    name: "createWeekMutation"
  }),
  graphql(CREATE_WEEKDAY_MUTATION, {
    name: "createWeekDayMutation"
  }),
  graphql(CREATE_OPTIONS_MUTATION, {
    name: "createOptionsMutation",
    options: ({ doctorId }) => ({ variables: { doctorId } })
  })
)(withRouter(CreateUser));



// WEBPACK FOOTER //
// ./src/components/CreateUser.js